import React, { useEffect, useState } from 'react';
import * as challengesApi from '../utils/challengesApi';
import AppIcon from './icons/AppIcon';
import '../styles/UserStatsPanel-Modern.css';

export default function UserStatsPanel() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await challengesApi.getChallengeStats();
        setStats(res.stats || res);
      } catch (e) {
        setStats(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="us-panel">
        <div className="us-loading"><AppIcon name="clock" size={18} /> Chargement...</div>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="us-panel">
        <div className="us-empty"><AppIcon name="empty" size={22} /> Aucune statistique</div>
      </div>
    );
  }

  const statCards = [
    {
      icon: 'clock',
      label: 'En cours',
      value: stats.inProgress || 0,
      color: 'blue',
      bgGradient: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)'
    },
    {
      icon: 'success',
      label: 'Complétés',
      value: stats.completed || 0,
      color: 'green',
      bgGradient: 'linear-gradient(135deg, #10b981 0%, #047857 100%)'
    },
    {
      icon: 'star',
      label: 'XP gagné',
      value: stats.totalXPEarned || 0,
      color: 'amber',
      bgGradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
    },
    {
      icon: 'activity',
      label: 'Taux réussite',
      value: `${stats.completionRate || 0}%`,
      color: 'purple',
      bgGradient: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)'
    }
  ];

  return (
    <div className="us-panel">
      <h3 className="us-title">Vos statistiques</h3>
      <div className="us-grid">
        {statCards.map((stat, idx) => (
          <div
            key={idx}
            className={`us-stat-card us-stat-${stat.color}`}
            style={{ backgroundImage: stat.bgGradient }}
          >
            <div className="us-stat-header">
              <div className="us-stat-icon"><AppIcon name={stat.icon} size={22} strokeWidth={1.8} /></div>
            </div>
            <div className="us-stat-content">
              <div className="us-stat-value">{stat.value}</div>
              <div className="us-stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
